import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BrandConfigService } from './brand-config.service';

@Injectable({ providedIn: 'root' })
export class FaviconService {
  private pendingImage: HTMLImageElement;

  constructor(@Inject(DOCUMENT) private document: Document, private branding: BrandConfigService) {}

  apply(): void {
    // Stop callbacks from an earlier update replacing the latest configuration.
    if (this.pendingImage) {
      this.pendingImage.onload = null;
      this.pendingImage.onerror = null;
      this.pendingImage = null;
    }
    const fallback = this.branding.getDefaultFavicon();
    this.setIcon(fallback);
    const src = this.branding.getFavicon();
    if (src === fallback) {
      return;
    }

    // Keep the default until the custom image decodes; never delay app startup.
    // A link's error event is not reliable for favicons across browsers.
    const image = this.document.createElement('img');
    this.pendingImage = image;
    const finish = (loaded: boolean) => {
      if (this.pendingImage !== image) {
        return;
      }
      image.onload = null;
      image.onerror = null;
      this.pendingImage = null;
      if (loaded) {
        this.setIcon(src);
      }
    };
    image.onload = () => finish(true);
    image.onerror = () => finish(false);
    image.src = src;
  }

  private setIcon(src: string): void {
    let link = this.document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    if (!link) {
      link = this.document.createElement('link');
      link.rel = 'icon';
      this.document.head.appendChild(link);
    }
    // Let the browser detect ICO/PNG/SVG instead of retaining the old ICO hint.
    link.removeAttribute('type');
    link.href = src;
  }
}
